import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/navbar.css'
function Navbar() {
  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    if(window.scrollY >= 34.5){
      setNavbar(true);
    }
    else{
      setNavbar(false);
    }
    
  }
  window.addEventListener('scroll', changeBackground);
  return (
    // {navbar ? "navbar nav-active" : "navbar"}
    <div className={navbar ? "navbar nav-active" : "navbar"}>
        
       <h3 className='h-3' >RISHABH</h3>
      <ul className="navbar-nav">
        <li className="nav-item">
        <NavLink className='nav-link btn-one' to="/">Home</NavLink>
        </li>
        <li className="nav-item">
        <NavLink className='nav-link btn-one' to="/about">About</NavLink>

        </li>
        
        <li className="nav-item">
        <NavLink className='nav-link btn-one' to="/contact">Contact</NavLink>
        </li>
        <li className="nav-item">
        <NavLink className='nav-link btn-one' to="/blog">Blogs</NavLink>
        </li>
      </ul>
      <div className="ocean">
  <div className="wave"></div>
  <div className="wave"></div>
  <div className="wave"></div>
</div>
    </div>
  );
}

export default Navbar;
